import { render, staticRenderFns } from "./completeSupervision.vue?vue&type=template&id=2ec07499&scoped=true"
import script from "./completeSupervision.vue?vue&type=script&lang=js"
export * from "./completeSupervision.vue?vue&type=script&lang=js"
import style0 from "./completeSupervision.vue?vue&type=style&index=0&id=2ec07499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec07499",
  null
  
)

export default component.exports